import React, { Fragment } from "react";
import "../PrimoSubscriptionModal/styles.scss";
import { Modal } from "react-bootstrap";
import { Elements, StripeProvider } from "react-stripe-elements";
import { useSelector } from "react-redux";
import TipjarCheckoutForm from "./TipjarCheckoutForm";
import { ReactComponent as CloseXIcon } from "../../../../public/icons/close-x-icon.svg";

function TipjarSubscriptionModal({ show, handleClose }) {
  const { current_user } = useSelector(({ current_user }) => ({
    current_user,
  }));

  return (
    <Modal className="primo" show={show} onHide={handleClose}>
      <div className="d-flex justify-content-end align-items-end p-3">
        <CloseXIcon className="close-icon" onClick={handleClose} />
      </div>
      <Modal.Body className="text-center p-5">
        <Fragment>
          <Modal.Title as="h1" className="text-dark font-weight-bold">
            Activate Your Tipjar
          </Modal.Title>
          <Fragment>
            {!current_user.is_subscribed_to_tipjar && (
              <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
                <Elements>
                  <TipjarCheckoutForm
                    onCheckoutDone={handleClose}
                    current_user={current_user}
                  />
                </Elements>
              </StripeProvider>
            )}
          </Fragment>
        </Fragment>
      </Modal.Body>
    </Modal>
  );
}
export default TipjarSubscriptionModal;
